// extracted by mini-css-extract-plugin
export var resizer = "_ey-0";